(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lgm-set"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSet(root) {
    if (!root || root.dataset.lgmReady === '1') return;
    root.dataset.lgmReady = '1';

    // Formato valuta: simbolo dal negozio + separatori dal locale → "€ 30,00".
    var symbol = root.dataset.symbol || '€';
    var locale = (document.documentElement.lang || 'it').trim() || 'it';
    function money(cents) {
      var n = (Number(cents) || 0) / 100;
      var s;
      try {
        s = n.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      } catch (e) {
        s = n.toFixed(2);
      }
      return symbol + ' ' + s;
    }

    var totalEl = root.querySelector('[data-total]');
    var submitBtn = root.querySelector('[data-submit]');
    var submitLabel = root.querySelector('[data-submit-label]');
    var statusEl = root.querySelector('[data-status]');
    var rowEls = Array.prototype.slice.call(root.querySelectorAll('[data-row]'));

    var defaultSubmitText = submitLabel ? submitLabel.textContent : 'Add everything to cart';

    function optionLabel(variant) {
      if (!variant) return '';
      var parts = [variant.o1, variant.o2, variant.o3].filter(function (x) {
        return x && String(x).trim() !== '' && String(x).toLowerCase() !== 'default title';
      });
      return parts.length ? parts.join(' / ') : (variant.title || '');
    }

    function clamp(n, lo, hi) {
      n = parseInt(n, 10);
      if (isNaN(n)) n = lo;
      return Math.min(hi, Math.max(lo, n));
    }

    // ---- Modello righe ----
    var rows = rowEls.map(function (rowEl) {
      var variants = [];
      var dataEl = rowEl.querySelector('[data-variants]');
      if (dataEl) {
        try { variants = JSON.parse(dataEl.textContent) || []; }
        catch (e) { variants = []; }
      }

      var optMode = rowEl.dataset.optMode || 'none';
      var min = clamp(rowEl.dataset.min, 0, 1e9);
      var max = clamp(rowEl.dataset.max, min, 1e9);
      var defQty = clamp(rowEl.dataset.defaultQty, min, max);

      if (optMode === 'colour') {
        var seen = {};
        variants = variants.filter(function (v) {
          var key = optionLabel(v).toLowerCase();
          if (seen[key]) return false;
          seen[key] = true;
          return true;
        });
      }

      var selected = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i] && variants[i].available) { selected = variants[i]; break; }
      }
      if (!selected && variants.length) selected = variants[0];
      var preferredId = parseInt(rowEl.dataset.defaultVariant, 10);
      if (preferredId) {
        var pref = variants.filter(function (v) { return v.id === preferredId; })[0];
        if (pref) selected = pref;
      }

      // Colour: una quantità per colore (parte da 0), invece di un'unica selezione.
      var colours = [];
      if (optMode === 'colour') {
        var colourStart = clamp(rowEl.dataset.defaultQty, 0, max);
        // I colori esauriti partono da 0: il loro stepper è disabilitato, quindi con una
        // quantità > 0 il cliente resterebbe bloccato ("Not available… Nothing was added.")
        // senza alcun modo di azzerarla.
        colours = variants.map(function (v) {
          return { v: v, qty: v.available ? colourStart : 0 };
        });
      }

      // Variante esaurita (card a stepper singolo): il massimo scende a 0, quindi la
      // riga esce dal totale e dal carrello e lo stepper si spegne. Senza questo, con
      // Minimum quantity >= 1 la quantità non poteva scendere sotto 1 e "Add to cart"
      // restava bloccato per sempre su "Nothing was added".
      var soldOut = optMode !== 'colour' && (!selected || !selected.available);
      if (soldOut) {
        min = 0;
        max = 0;
        defQty = 0;
      }

      return {
        el: rowEl,
        optMode: optMode,
        soldOut: soldOut,
        min: min,
        max: max,
        qty: defQty,
        label: rowEl.dataset.productTitle || 'Product',
        variants: variants,
        selected: selected,
        colours: colours,
        figureImg: rowEl.querySelector('.lgm-set__card-img'),
        unitEl: rowEl.querySelector('[data-unit-price]'),
        warnEl: rowEl.querySelector('[data-row-warn]'),
        qtyEl: rowEl.querySelector('[data-qty]'),
        minusBtn: rowEl.querySelector('[data-step="-1"]'),
        plusBtn: rowEl.querySelector('[data-step="1"]'),
        selectEl: rowEl.querySelector('[data-select]'),
        colourGridEl: rowEl.querySelector('[data-colour-grid]')
      };
    });

    // ---- Render selettori ----
    rows.forEach(function (row) {
      if (row.optMode === 'size' && row.selectEl) {
        row.selectEl.innerHTML = '';
        row.variants.forEach(function (v) {
          var opt = document.createElement('option');
          opt.value = String(v.id);
          var txt = (v.title && v.title.toLowerCase() !== 'default title') ? v.title : (optionLabel(v) || row.label);
          opt.textContent = txt + ' — ' + money(v.price) + (v.available ? '' : ' (Sold out)');
          opt.disabled = !v.available;
          if (row.selected && v.id === row.selected.id) opt.selected = true;
          row.selectEl.appendChild(opt);
        });
        row.selectEl.addEventListener('change', function () {
          var id = parseInt(row.selectEl.value, 10);
          row.selected = row.variants.filter(function (v) { return v.id === id; })[0] || row.selected;
          updateRow(row);
          updateTotal();
        });
      } else if (row.optMode === 'colour' && row.colourGridEl) {
        var grid = row.colourGridEl;
        grid.innerHTML = '';
        // Figure ricamo (dalla libreria) → pastiglie grandi: a 28px un motivo è illeggibile.
        var hasFigures = row.colours.some(function (c) { return c.v && c.v.swBig; });
        if (hasFigures) grid.classList.add('lgm-set__colours--figures');
        row.colours.forEach(function (c) {
          // c.v.label = solo i valori che variano (dal Liquid); fallback al titolo completo.
          var name = c.v.label || optionLabel(c.v) || c.v.title || '';

          var unit = document.createElement('div');
          unit.className = 'lgm-set__colour';

          var sw = document.createElement('span');
          sw.className = 'lgm-set__colour-sw';
          if (c.v.swImg) { sw.style.backgroundImage = 'url("' + c.v.swImg + '")'; }
          else if (c.v.swColor) { sw.style.backgroundColor = c.v.swColor; }
          else { sw.setAttribute('data-noimg', ''); }

          var nameEl = document.createElement('span');
          nameEl.className = 'lgm-set__colour-name';
          nameEl.textContent = name;

          var step = document.createElement('div');
          step.className = 'lgm-set__cstep';
          step.setAttribute('role', 'group');
          step.setAttribute('aria-label', name + ' — quantity');

          var minus = document.createElement('button');
          minus.type = 'button';
          minus.className = 'lgm-set__cstep-btn';
          minus.innerHTML = '&minus;';
          minus.setAttribute('aria-label', 'Decrease ' + name);

          var qEl = document.createElement('input');
          qEl.className = 'lgm-set__cstep-qty';
          qEl.type = 'text';
          qEl.inputMode = 'numeric';
          qEl.setAttribute('pattern', '[0-9]*');
          qEl.value = String(c.qty);
          qEl.setAttribute('aria-label', name + ' quantity');

          var plus = document.createElement('button');
          plus.type = 'button';
          plus.className = 'lgm-set__cstep-btn';
          plus.textContent = '+';
          plus.setAttribute('aria-label', 'Increase ' + name);

          c.qtyEl = qEl;
          c.minusBtn = minus;
          c.plusBtn = plus;

          if (!c.v.available) {
            unit.setAttribute('data-soldout', '');
            minus.disabled = true;
            plus.disabled = true;
            qEl.disabled = true;
          } else {
            minus.disabled = c.qty <= 0; // dipende dalla quantità di partenza (Default quantity)
            plus.disabled = c.qty >= row.max;
          }

          minus.addEventListener('click', function () { setColourQty(row, c, c.qty - 1); });
          plus.addEventListener('click', function () { setColourQty(row, c, c.qty + 1); });
          qEl.addEventListener('input', function () {
            var cleaned = qEl.value.replace(/[^0-9]/g, '');
            if (cleaned !== qEl.value) qEl.value = cleaned;
          });
          qEl.addEventListener('change', function () { setColourQty(row, c, qEl.value); });
          qEl.addEventListener('blur', function () { setColourQty(row, c, qEl.value); });

          unit.appendChild(sw);
          unit.appendChild(nameEl);

          if (c.v.available) {
            step.appendChild(minus);
            step.appendChild(qEl);
            step.appendChild(plus);
            unit.appendChild(step);
          } else {
            // Al posto dello stepper spento — che mostrando "0" non spiega niente —
            // si scrive perché non si può comprare. Occupa lo stesso spazio, quindi
            // le pastiglie restano allineate fra loro.
            var out = document.createElement('span');
            out.className = 'lgm-set__cout';
            out.textContent = 'Sold out';
            unit.appendChild(out);
          }

          grid.appendChild(unit);
        });
      }
    });

    function setColourQty(row, c, val) {
      c.qty = clamp(val, 0, row.max);
      if (c.qtyEl) c.qtyEl.value = String(c.qty);
      if (c.minusBtn) c.minusBtn.disabled = !c.v.available || c.qty <= 0;
      if (c.plusBtn) c.plusBtn.disabled = !c.v.available || c.qty >= row.max;
      updateTotal();
    }

    // ---- Aggiornamento riga ----
    function updateRow(row) {
      if (row.optMode === 'colour') {
        // Prezzo unitario (i colori condividono lo stesso prezzo); niente stepper singolo.
        if (row.unitEl) {
          var pv0 = row.variants[0];
          row.unitEl.textContent = pv0 ? money(pv0.price) : '';
        }
        return;
      }
      // Solo le righe con <select> cambiano variante a runtime. Altrove il Liquid ha già
      // reso l'immagine giusta (responsive, con srcset): sostituirla al primo giro
      // scaricherebbe una SECONDA foto per ogni card, buttando via il srcset.
      if (row.selectEl && row.figureImg && row.selected && row.selected.image) {
        row.figureImg.removeAttribute('srcset');
        row.figureImg.removeAttribute('sizes');
        row.figureImg.src = row.selected.image;
      }

      // Prezzo UNITARIO (la card mostra il prezzo per pezzo, come nel riferimento).
      if (row.unitEl) {
        row.unitEl.textContent = row.selected ? money(row.selected.price) : '';
      }

      if (row.qtyEl) {
        row.qtyEl.value = String(row.qty);
        row.qtyEl.disabled = row.soldOut;
      }
      if (row.minusBtn) row.minusBtn.disabled = row.soldOut || row.qty <= row.min;
      if (row.plusBtn) row.plusBtn.disabled = row.soldOut || row.qty >= row.max;
      row.el.toggleAttribute('data-soldout', !!row.soldOut);

      if (row.warnEl) {
        if (row.soldOut) {
          // Detto una volta e basta: lo stepper è già spento e la riga è già fuori dal
          // totale, quindi non c'è nessuna azione da suggerire al cliente.
          row.warnEl.textContent = row.selected ? 'Sold out' : 'Not available';
          row.warnEl.hidden = false;
        } else {
          row.warnEl.hidden = true;
          row.warnEl.textContent = '';
        }
      }
    }

    function setQty(row, val) {
      row.qty = clamp(val, row.min, row.max);
      updateRow(row);
      updateTotal();
    }

    rows.forEach(function (row) {
      if (row.minusBtn) {
        row.minusBtn.addEventListener('click', function () { setQty(row, row.qty - 1); });
      }
      if (row.plusBtn) {
        row.plusBtn.addEventListener('click', function () { setQty(row, row.qty + 1); });
      }
      if (row.qtyEl) {
        row.qtyEl.addEventListener('input', function () {
          var cleaned = row.qtyEl.value.replace(/[^0-9]/g, '');
          if (cleaned !== row.qtyEl.value) row.qtyEl.value = cleaned;
        });
        row.qtyEl.addEventListener('change', function () { setQty(row, row.qtyEl.value); });
        row.qtyEl.addEventListener('blur', function () { setQty(row, row.qtyEl.value); });
      }
    });

    // ---- Totale ----
    function updateTotal() {
      var total = 0;
      rows.forEach(function (row) {
        if (row.optMode === 'colour') {
          row.colours.forEach(function (c) {
            if (c.qty > 0 && c.v.available) total += (Number(c.v.price) || 0) * c.qty;
          });
          return;
        }
        if (!row.selected || row.qty <= 0) return;
        if (!row.selected.available) return;
        total += (Number(row.selected.price) || 0) * row.qty;
      });
      if (totalEl) totalEl.textContent = money(total);
    }

    // ---- Add to cart ----
    var statusTimer = null;
    function setStatus(msg, state) {
      if (!statusEl) return;
      if (statusTimer) { clearTimeout(statusTimer); statusTimer = null; }
      statusEl.textContent = msg || '';
      if (state) statusEl.setAttribute('data-state', state);
      else statusEl.removeAttribute('data-state');
      // Successo: auto-cancella dopo 4s così lo status torna vuoto e non riapre
      // la fascia ~35px sopra la griglia (lo status non riserva spazio se :empty).
      if (state === 'success' && msg) {
        statusTimer = setTimeout(function () { setStatus('', null); }, 4000);
      }
    }

    function setBusy(on) {
      if (!submitBtn) return;
      submitBtn.setAttribute('aria-busy', on ? 'true' : 'false');
      submitBtn.disabled = !!on;
      if (submitLabel && !on) submitLabel.textContent = defaultSubmitText;
    }

    // Apre il drawer del carrello dopo l'aggiunta. Il set aggiunge più prodotti insieme,
    // quindi non può usare il form nativo con on_success="force_open_drawer" (quello manda
    // un prodotto solo): si prova il metodo del custom element e, se non c'è, si clicca il
    // pulsante che lo comanda. Se non trova né l'uno né l'altro non fa niente — comportamento
    // di prima, nessun errore.
    function openCartDrawer() {
      var d = document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
      if (d) {
        if (typeof d.show === 'function') { d.show(); return; }
        if (typeof d.open === 'function') { d.open(); return; }
      }
      var t = document.querySelector('[aria-controls="cart-drawer"]');
      if (t) t.click();
    }

    function buildItems() {
      var items = [];
      var missing = [];
      rows.forEach(function (row) {
        if (row.optMode === 'colour') {
          row.colours.forEach(function (c) {
            if (c.qty <= 0) return;
            if (!c.v.available) { missing.push(row.label + ' — ' + (optionLabel(c.v) || '') + ' (Sold out)'); return; }
            items.push({ id: c.v.id, quantity: c.qty });
          });
          return;
        }
        if (row.qty <= 0) return;
        if (!row.variants.length) { missing.push(row.label + ' (no variant configured)'); return; }
        if (!row.selected) { missing.push(row.label + ' (no selection)'); return; }
        if (!row.selected.available) { missing.push(row.label + ' (Sold out)'); return; }
        items.push({ id: row.selected.id, quantity: row.qty });
      });
      return { items: items, missing: missing };
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function () {
        if (submitBtn.getAttribute('aria-busy') === 'true') return;
        setStatus('', null);

        var built = buildItems();
        if (built.missing.length) {
          setStatus('Not available: ' + built.missing.join(', ') + '. Nothing was added.', 'error');
          return;
        }
        if (!built.items.length) {
          setStatus('Add at least one piece (set a quantity above 0).', 'error');
          return;
        }

        setBusy(true);
        setStatus('Adding to cart…', null);

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: built.items })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok, status: res.status, data: data };
            });
          })
          .then(function (r) {
            if (r.ok) {
              setStatus('Added to cart.', 'success');
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true })
              );
              openCartDrawer();
            } else {
              var who = '';
              if (r.data) {
                if (r.data.description) who = r.data.description;
                else if (r.data.message) who = r.data.message;
              }
              var badId = r.data && r.data.id ? parseInt(r.data.id, 10) : null;
              var label = null;
              if (badId) {
                rows.forEach(function (row) {
                  if (row.selected && row.selected.id === badId) label = row.label;
                  if (row.colours) {
                    row.colours.forEach(function (c) { if (c.v.id === badId) label = row.label; });
                  }
                });
              }
              var msg = label
                ? ('“' + label + '” is not available in the requested quantity. Nothing was added.')
                : ((who || 'One of the pieces is not available.') + ' Nothing was added.');
              setStatus(msg, 'error');
            }
          })
          .catch(function () {
            setStatus('Network error. Please try again.', 'error');
          })
          .then(function () {
            setBusy(false);
          });
      });
    }

    // ---- Init ----
    rows.forEach(updateRow);
    updateTotal();
  }

  function boot() {
    document.querySelectorAll('[data-lgm-set]').forEach(initSet);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target.querySelector ? e.target.querySelector('[data-lgm-set]') : null;
    if (node) { node.dataset.lgmReady = ''; initSet(node); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lgm-variant-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(scroller) {
    if (!scroller || scroller.dataset.lgmNavReady === '1') return;
    scroller.dataset.lgmNavReady = '1';

    var ul = scroller.querySelector('ul.lgm-vgrid__grid');
    var prev = scroller.querySelector('[data-scroll-prev]');
    var next = scroller.querySelector('[data-scroll-next]');
    if (!ul || !prev || !next) return;

    function maxScroll() { return ul.scrollWidth - ul.clientWidth; }

    function update() {
      var max = maxScroll();
      var overflow = max > 2;
      var x = ul.scrollLeft;
      prev.hidden = !overflow || x <= 2;
      next.hidden = !overflow || x >= max - 2;
    }

    function step(dir) {
      var amount = Math.max(ul.clientWidth * 0.8, 200);
      ul.scrollBy({ left: dir * amount, behavior: REDUCE ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    ul.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) { new ResizeObserver(update).observe(ul); }
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(update); }
    window.addEventListener('load', update);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.lgm-vgrid__scroller').forEach(init);
  }

  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', function () { initAll(); }); }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
